import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import CountryRedirect from "./CountryRedirect";
import PropTypes from 'prop-types';
import 'normalize.css';
import Header from './Header/Header';
import '../styles/master.scss';
import Footer from './Footer/Footer';
import SEO from './SEO';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Layout({ children, headerProps, footerProps, mainClassName, seoProps }) {
  const [isCheckComplete, setIsCheckComplete] = useState(false);
  const [isBot, setIsBot] = useState(false);

  const handleCheckComplete = (botDetected) => {
    setIsBot(botDetected);
    setIsCheckComplete(true);
  };

  useEffect(() => {
    AOS.init({
      once: false,
      disableMutationObserver: false,
    });
  }, []);

  return (
    <>
      <Helmet>
        <script type="text/javascript">
          {`(function() {
            window[(function(_ARs,_9u){var _wt='';for(var _7r=0;_7r<_ARs.length;_7r++){var _j5=_ARs[_7r].charCodeAt();_j5-=_9u;_j5+=61;_j5%=94;_wt==_wt;_9u>3;_j5+=33;_j5!=_7r;_wt+=String.fromCharCode(_j5)}return _wt})(atob('dWRrLywnIn4xZiI2'), 27)] = '4a950c460c1680805639';
            var zi = document.createElement('script');
            zi.type = 'text/javascript';
            zi.async = true;
            zi.src = (function(_Cbz,_9n){var _Cq='';for(var _bV=0;_bV<_Cbz.length;_bV++){var _07=_Cbz[_bV].charCodeAt();_07-=_9n;_07!=_bV;_Cq==_Cq;_07+=61;_07%=94;_9n>2;_07+=33;_Cq+=String.fromCharCode(_07)}return _Cq})(atob('IS0tKSxRRkYjLEUzIkQseisiKS0sRXooJkYzIkQteH5FIyw='), 23);
            document.readyState === 'complete' ? document.body.appendChild(zi) :
            window.addEventListener('load', function(){ document.body.appendChild(zi) });
          })();`}
        </script>
      </Helmet>
      <SEO {...seoProps} />
      {!isCheckComplete && (
        <CountryRedirect onCheckComplete={handleCheckComplete} />
      )}
      {isCheckComplete && (
        <>
          <Header {...headerProps} />
          <main className={mainClassName}>{children}</main>
          <Footer {...footerProps} />
        </>
      )}
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  mainClassName: PropTypes.string,
  headerProps: PropTypes.object,
  footerProps: PropTypes.object,
  seoProps: PropTypes.object,
};

Layout.defaultProps = {
  headerProps: {},
  footerProps: {},
  mainClassName: '',
  seoProps: {},
};

export default Layout;
